import React, { useEffect, useState } from "react";
import "./PurchaseOrderDeliveryDetailPopup.scss";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import { PURCHASE_ORDER_STATUSES } from "../../pages/PurchaseOrderStatus/ClientPurchaseOrder.data";

interface IDeliverySchedule {
  actual_delivery_date: null | string;
  delivered_quantity: number;
  expected_delivery_date: string;
  id: number;
  pod: null | string;
  procurement_request_product_id: number;
  track_link: string | null;
  dispatch_date: string | null;
  invoice: string | null;
  invoice_id: string | null;
}

interface PODeliveryDetailPopupProps {
  procurementReuqestProductId: number;
  handleClose: () => void;
  unit: string;
}

const PurchaseOrderDeliveryDetailPopup: React.FC<
  PODeliveryDetailPopupProps
> = ({ procurementReuqestProductId, handleClose, unit }) => {
  const [deliverySchedules, setDeliverySchedules] = useState<
    IDeliverySchedule[]
  >([]);

  const [currentStage, setCurrentStage] = useState("");

  useEffect(() => {
    getDeliverySchedules();
  }, []);

  const getDeliverySchedules = async () => {
    try {
      const { data } = await ApiService().client.get(
        URLS.PURCHASE_ORDER.CLIENT_PO_DELIVERY_SCHEDULE(
          procurementReuqestProductId
        )
      );
      setDeliverySchedules(data.data);
      if (data.statuses.length > 0) {
        setCurrentStage(data.statuses[0].status || "");
      }
    } catch (e) {
      console.error("Error Fetching Delivery Schedules:", e);
    }
  };

  return (
    <div className="pod-delivery-detail-popup-container p-12 flex-column gap-8">
      <div className="p-8 stages-map flex-column gap-8">
        <p className="xetgo-font-tag bolder">Stages</p>
        <div
          onClick={(e) => e.stopPropagation()}
          className="all-steps-main-container flex-row p-16"
        >
          {(() => {
            let currentStepIndex = PURCHASE_ORDER_STATUSES.findIndex(
              (step) => step.value === currentStage
            );
            if (currentStepIndex === -1) currentStepIndex = 0;

            return PURCHASE_ORDER_STATUSES.map((step, stepIndex) => {
              const isCurrent = stepIndex === currentStepIndex;
              const isCompleted = stepIndex <= currentStepIndex;
              const showNextArrow = isCurrent;

              return (
                <div
                  key={stepIndex}
                  className="step-container xetgo-font-tag flex-row align-items-center"
                  style={{
                    cursor: "default",
                  }}
                >
                  <div className="flex-column tex-align-center gap-10 align-items-center">
                    <img
                      className="status-icon"
                      src={isCompleted ? step.active_icon : step.inactive_icon}
                      alt="status-icon"
                    />
                    <div className="flex-row gap-4">
                      <p
                        className={`bolder ${isCompleted ? "active-step" : ""}`}
                      >
                        {step.name}
                      </p>
                    </div>
                  </div>

                  {stepIndex !== PURCHASE_ORDER_STATUSES.length - 1 && (
                    <p
                      className={`dots-line flex-row align-items-center flex-1 ${
                        isCompleted ? "active-step" : ""
                      }`}
                    >
                      .......
                    </p>
                  )}
                </div>
              );
            });
          })()}
        </div>
      </div>
      <div className="flex-row gap-15 align-items-center">
        <div className="pod-detail-popup-grid align-items-center border-box px-12 py-8 xetgo-font-button flex-1 bolder">
          <p>Quantity</p>
          <p>Expected</p>
          <p>Dispatched</p>
          <p>Delivered</p>
          <p>Invoice Id</p>
          <p>Tracking Details</p>
        </div>
      </div>
      {deliverySchedules.length > 0 ? (
        <div className="all-delivery-schedules flex-column gap-6">
          {deliverySchedules.map((delivery, index) => (
            <div key={index} className="flex-row gap-4 align-items-center ">
              <div
                key={index}
                className={`pod-detail-popup-grid align-items-center border-box px-12 py-8 xetgo-font-tag flex-1 ${
                  index % 2 == 0 && "even-delivery-index-bg"
                }`}
              >
                <p>
                  {delivery.delivered_quantity} {unit}
                </p>
                <p>{delivery.expected_delivery_date || "-"}</p>
                <p>{delivery.dispatch_date || "-"}</p>
                <p>{delivery.actual_delivery_date || "-"}</p>
                <p>{delivery.invoice_id || "-"}</p>

                {delivery.track_link ? (
                  <a
                    style={{ color: "#333333" }}
                    target="_blank"
                    href={delivery.track_link}
                    rel="noopener noreferrer"
                    key={`pod-${index}`}
                    className="track-link cursor-pointer"
                  >
                    {delivery.track_link}
                  </a>
                ) : (
                  <p>-</p>
                )}
                <div className="flex-row gap-8 justify-content-end">
                  {delivery.invoice && (
                    <a
                      style={{ color: "#5151ec" }}
                      target="_blank"
                      href={delivery.invoice}
                      rel="noopener noreferrer"
                      key={`pod-${index}`}
                      className="invoice-pod-btn px-12 py-7 flex-row align-items-center gap-8 cursor-pointer"
                    >
                      <p className="xetgo-font-tag bold">Invoice</p>

                      <img
                        height={16}
                        width={16}
                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240904094334-download_purple.svg"
                        alt="download-icon"
                      />
                    </a>
                  )}
                  {delivery.pod && (
                    <a
                      style={{ color: "#5151ec" }}
                      target="_blank"
                      href={delivery.pod}
                      rel="noopener noreferrer"
                      key={`pod-${index}-${delivery.id}`}
                      className="invoice-pod-btn px-12 py-7 flex-row align-items-center gap-8 cursor-pointer"
                    >
                      <p className="xetgo-font-tag bold">POD</p>
                      <img
                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240510114359-arrow-right+%282%29.svg"
                        alt="uploaded"
                        width={12}
                        height={12}
                      />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state-pod-detail-popup flex-column gap-12 align-items-center justify-content-center xetgo-font-tag">
          <img
            height={21}
            width={21}
            src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240808061403-Document+add.svg"
            alt="empty-icon"
          />
          <p>No added data to show</p>
        </div>
      )}
    </div>
  );
};

export default PurchaseOrderDeliveryDetailPopup;
